/**
 * rankingPosterCard.tsx
 */
import Card from '@shared/types/props/card';
import Event from '@shared/classes/event';
import RankingContainer from '@components/atoms/container/rankingPositionContainer';
import VerticalCard from './verticalCard';
import { memo } from 'react';

/**
 * Ranking poster card component.
 */
function RankingPosterCard(props: Card) {
  const item = props.item as Event;
  return (
    <div style={{ display: props.hide ? 'none' : 'flex' }}>
      <RankingContainer position={item?.position} hide={props.hide} vertical>
        {item?.position !== undefined ? `${item?.position}` : ''}
      </RankingContainer>
      <VerticalCard {...props} />
    </div>
  );
}

export default memo(RankingPosterCard);
